import { render, staticRenderFns } from "./badgePage.vue?vue&type=template&id=00722970&scoped=true"
import script from "./badgePage.vue?vue&type=script&lang=js"
export * from "./badgePage.vue?vue&type=script&lang=js"
import style0 from "./badgePage.vue?vue&type=style&index=0&id=00722970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00722970",
  null
  
)

export default component.exports